module.exports = __webpack_public_path__ + "static/media/ic_align_center.e3b19973.svg";